import React from "react"
import Content from "../components/content.js"
import { processYoutubeDetails } from '../components/functions.js'
import { graphql } from "gatsby"
import Layout from "../layouts"
import SearchEngineOptim from "../components/seo.js"

const Post = (props) => {
    const post = props.data.wpPost;
    
    var seoImage = null;
    if(post.featuredImage) {
      seoImage = post.featuredImage.node.localFile.publicURL;
    }

    if(post.postsACF.embed) {
      var youtubeDetails = processYoutubeDetails(post.postsACF.embed);
      seoImage = youtubeDetails.thumbnail_src;
    }

    // var clean_title = null;
    // if(post.title) {
    //   clean_title = post.title.substring(0, 70);
    // }

    var clean_description = null;
    if(post.content) {
      clean_description = post.content.replace(/<\/?[^>]+(>|$)/g, "");
      clean_description = clean_description.substring(0, 170);
    }

    return (
    <Layout>
      <SearchEngineOptim
        title={post.title}
        description={clean_description}
        image={seoImage}
      />
      {post && (
        <Content node={post} format="single" />
      )}
    </Layout>
    )
}

export default Post

export const pageQuery = graphql`
  query PostById($id: String!) {
    wpPost(
      id: { eq: $id }
    ) {
      id
      databaseId
      title
      slug
      uri
      date
      status
      content
      featuredImage {
        node {
          altText
          width
          height
          caption
          localFile {
            publicURL
            childImageSharp {
              lb: gatsbyImageData(
                layout: CONSTRAINED
                placeholder: BLURRED
                blurredOptions: {
                  width: 40
                }
                width: 2400
                formats: [JPG, WEBP]
              )
              gatsbyImageData(
                layout: CONSTRAINED
                placeholder: BLURRED
                blurredOptions: {
                  width: 40
                }
                width: 1200
                formats: [JPG, WEBP]
              )
            }
          }
        }
      }
      categories {
        nodes {
          id
          name
          slug
          uri
        }
      }
      tags {
        nodes {
          id
          name
          slug
          uri
          count
        }
      }
      postsACF {
        embed
        sourceUrl
        viaUrl
        css
        location {
          latitude
          longitude
          zoom
        }
        locationKml {
          node {
            localFile {
              publicURL
            }
          }
        }
        gallery {
          nodes {
            altText
            caption
            localFile {
              id
              publicURL
              childImageSharp {
                lb: gatsbyImageData(
                  layout: CONSTRAINED
                  placeholder: BLURRED
                  blurredOptions: {
                    width: 40
                  }
                  width: 2400
                  formats: [JPG, WEBP]
                )
                gatsbyImageData (
                  layout: CONSTRAINED
                  placeholder: BLURRED
                  blurredOptions: {
                    width: 20
                  }
                  width: 600
                )
              }
            }
          }
        }
        relatedTo {
          nodes {
            ... on WpPost {
              id
              uri
              title
            }
          }
        }
        featuredImageVideo {
          node {
            mediaDetails {
              height
              width
            }
            localFile {
              publicURL
            }
            mimeType
          }
        }
      }
    }
  }
`
